require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./svgicon"), require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./svgicon", "./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./svgicon"), require("./utils")) : factory(root["./svgicon"], root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__56685__, __WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[3413],{

/***/ 65735:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _reactResizable = __webpack_require__(95103);
var _svgicon = _interopRequireDefault(__webpack_require__(56685));
var _resizePanel_ = _interopRequireDefault(__webpack_require__(3591));
var _Container = _interopRequireDefault(__webpack_require__(11608));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const {
  sizeArrayToCss,
  mergeStyles
} = _utils.cssUtils;
const {
  sanitize
} = _utils.propsUtils;
const {
  isKey,
  keyNames
} = _utils.keyboardUtils;
const containerClassName = _Container.default.containerClassName.replace(/"/g, '');
const KB_RESIZE_STEP = 5;
class Container extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "_onResize", (event, data) => {
      this.setState({
        width: data.size.width,
        height: data.size.height
      });
      this.props.onResize(event, data);
    });
    (0, _defineProperty2.default)(this, "_handler", h => /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      "aria-label": "resizable-container__handler",
      "data-tid": "ba-common-resizable-container__handler",
      className: `resize-handler-icon resize-handler-icon-${h}`,
      tabIndex: "0",
      onKeyDown: this._onResizeHandlerKeyDown,
      iconId: _resizePanel_.default.id
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: `react-resizable-handle react-resizable-handle-${h}`
    })));
    (0, _defineProperty2.default)(this, "_onResizeHandlerKeyDown", e => {
      const {
        LEFT,
        RIGHT,
        UP,
        DOWN
      } = keyNames;
      const {
        resizeDirection,
        resizeMinConstraintsX,
        resizeMaxConstraintsX,
        resizeMinConstraintsY,
        resizeMaxConstraintsY
      } = this.props;
      const {
        width,
        height
      } = this.state;
      if (isKey(e, LEFT) || isKey(e, RIGHT) || isKey(e, UP) || isKey(e, DOWN)) {
        if (resizeDirection === 'x') {
          if (isKey(e, LEFT) && resizeMinConstraintsX <= width - KB_RESIZE_STEP) {
            this.setState({
              width: width - KB_RESIZE_STEP
            });
          } else if (isKey(e, RIGHT) && resizeMaxConstraintsX >= width + KB_RESIZE_STEP) {
            this.setState({
              width: width + KB_RESIZE_STEP
            });
          }
        } else if (resizeDirection === 'y') {
          if (isKey(e, UP) && resizeMinConstraintsY <= height - KB_RESIZE_STEP) {
            this.setState({
              height: height - KB_RESIZE_STEP
            });
          } else if (isKey(e, DOWN) && resizeMaxConstraintsY >= height + KB_RESIZE_STEP) {
            this.setState({
              height: height + KB_RESIZE_STEP
            });
          }
        }
        e.preventDefault();
      }
    });
    (0, _defineProperty2.default)(this, "_ref", node => {
      this._node = node;
    });
    this.state = {
      width: 0,
      height: 0
    };
  }
  componentDidMount() {
    const {
      resizable
    } = this.props;
    if (resizable) {
      this.setState({
        height: this._node.offsetHeight,
        width: this._node.offsetWidth
      });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      resizable
    } = this.props;
    if (resizable && (prevState.height !== this._node.offsetHeight || prevState.width !== this._node.offsetWidth)) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        height: this._node.offsetHeight,
        width: this._node.offsetWidth
      });
    }
  }
  render() {
    const {
      children,
      gutter,
      margin,
      padding,
      width,
      height,
      minWidth,
      minHeight,
      maxWidth,
      maxHeight,
      overflow,
      relative,
      textAlign,
      style,
      resizable,
      resizeDirection,
      resizeMinConstraintsX,
      resizeMinConstraintsY,
      resizeMaxConstraintsX,
      resizeMaxConstraintsY,
      className,
      onResizeStart,
      onResizeStop,
      id,
      isPassive,
      resizeHandles,
      ...others
    } = this.props;
    const styles = mergeStyles(style, {
      overflow,
      width,
      height,
      minWidth,
      minHeight,
      maxWidth,
      maxHeight,
      textAlign,
      margin: sizeArrayToCss(margin),
      padding: sizeArrayToCss(gutter || padding)
    });
    if (relative) {
      styles.position = 'relative';
    }
    const adjustedWidth = this.state.width === 0 ? this.props.width : this.props.isPassive ? this.props.width : this.state.width;
    const adjustedHeight = this.state.height === 0 ? this.props.height : this.props.isPassive ? this.props.height : this.state.height;
    const classNames = (0, _utils.classnames)(containerClassName);
    const containerComponentClass = `${classNames} ${className}`;
    let defaultResizeHandles;
    if (resizable) {
      if (resizeHandles === undefined) {
        switch (resizeDirection) {
          case 'x':
            defaultResizeHandles = ['e'];
            break;
          case 'y':
            defaultResizeHandles = ['s'];
            break;
          case 'both':
            defaultResizeHandles = ['se'];
            break;
          default:
        }
      }
      return /*#__PURE__*/_react.default.createElement(_reactResizable.Resizable, (0, _extends2.default)({}, sanitize(others, Container), {
        axis: resizeDirection
        // BAUICOMMON-803 Expression editor window fix
        // if the browser is being resized then pass props.width and props.height to respect browser size
        ,
        height: isPassive ? height : this.state.height,
        width: isPassive ? width : this.state.width,
        onResize: this._onResize,
        onResizeStart: onResizeStart,
        onResizeStop: onResizeStop,
        minConstraints: [resizeMinConstraintsX, resizeMinConstraintsY],
        maxConstraints: [resizeMaxConstraintsX, resizeMaxConstraintsY],
        resizeHandles: resizeHandles === undefined ? defaultResizeHandles : resizeHandles,
        handle: this._handler
      }), /*#__PURE__*/_react.default.createElement("div", {
        id: id,
        className: (0, _utils.classnames)(containerComponentClass, resizeDirection),
        style: {
          ...styles,
          // BAUICOMMON-803 Expression editor window fix
          // if the browser is being resized then pass props.width and props.height to respect browser size
          width: adjustedWidth,
          height: adjustedHeight
        },
        ref: this._ref
      }, children));
    }
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      id: id,
      className: containerComponentClass,
      ref: this._ref
    }, sanitize(others, Container), {
      style: styles
    }), children);
  }
}
exports["default"] = Container;
(0, _defineProperty2.default)(Container, "propTypes", {
  gutter: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array]),
  margin: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array]),
  padding: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array]),
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  minWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  minHeight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  maxWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  maxHeight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  overflow: _propTypes.default.string,
  relative: _propTypes.default.bool,
  children: _propTypes.default.node,
  textAlign: _propTypes.default.oneOf(['left', 'right', 'center']),
  style: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  resizable: _propTypes.default.bool,
  resizeDirection: _propTypes.default.oneOf(['both', 'x', 'y', 'none']),
  resizeMinConstraintsX: _propTypes.default.number,
  resizeMinConstraintsY: _propTypes.default.number,
  resizeMaxConstraintsX: _propTypes.default.number,
  resizeMaxConstraintsY: _propTypes.default.number,
  onResize: _propTypes.default.func,
  onResizeStart: _propTypes.default.func,
  onResizeStop: _propTypes.default.func,
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  resizeHandles: _propTypes.default.array,
  isPassive: _propTypes.default.bool // to allow caller control the size by width and height props
});
(0, _defineProperty2.default)(Container, "defaultProps", {
  resizable: false,
  resizeDirection: 'x',
  className: '',
  style: {},
  resizeMinConstraintsX: 32,
  resizeMinConstraintsY: 32,
  resizeMaxConstraintsX: Number.POSITIVE_INFINITY,
  resizeMaxConstraintsY: Number.POSITIVE_INFINITY,
  onResize: () => {},
  onResizeStart: () => {},
  onResizeStop: () => {}
});

/***/ }),

/***/ 2173:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _Container = _interopRequireDefault(__webpack_require__(65735));
exports["default"] = _Container.default;
exports.Container = _Container.default;

/***/ }),

/***/ 21946:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-container.react-resizable svg.resize-handler-icon:focus{outline:2px solid #a8c0f3}.ba-common-container.react-resizable{position:relative}.ba-common-container.react-resizable svg.resize-handler-icon{position:absolute;margin:auto;display:block;z-index:2}.ba-common-container.react-resizable .react-resizable-handle{background-color:#eaeaea;box-sizing:border-box;position:absolute;margin:auto}@media screen and (-ms-high-contrast: active){.ba-common-container.react-resizable .react-resizable-handle{border:1px solid #fff}}.ba-common-container.react-resizable.is-x{padding-right:8px;height:100% !important}.ba-common-container.react-resizable.is-x svg.resize-handler-icon-e{width:8px;top:0;bottom:0;right:0}.ba-common-container.react-resizable.is-x svg.resize-handler-icon-w{width:8px;top:0;bottom:0;left:0}.ba-common-container.react-resizable.is-x .react-resizable-handle-e{width:8px;height:100%;top:0;bottom:0;right:0;cursor:col-resize}.ba-common-container.react-resizable.is-x .react-resizable-handle-w{width:8px;height:100%;top:0;bottom:0;left:0;cursor:col-resize}.ba-common-container.react-resizable.is-y{padding-bottom:8px;width:100% !important}.ba-common-container.react-resizable.is-y svg.resize-handler-icon-s{height:16px;left:50%;bottom:-4px;transform:rotate(90deg)}.ba-common-container.react-resizable.is-y svg.resize-handler-icon-n{height:16px;left:50%;top:-4px;transform:rotate(90deg)}.ba-common-container.react-resizable.is-y .react-resizable-handle-n{height:8px;width:100%;top:0;right:0;left:0;cursor:row-resize}.ba-common-container.react-resizable.is-y .react-resizable-handle-s{height:8px;width:100%;bottom:0;right:0;left:0;cursor:row-resize}.ba-common-container.react-resizable.is-both svg.resize-handler-icon-se{width:16px;height:16px;right:0;bottom:0}.ba-common-container.react-resizable.is-both svg.resize-handler-icon-sw{width:16px;height:16px;bottom:0px;left:0px}.ba-common-container.react-resizable.is-both svg.resize-handler-icon-nw{width:16px;height:16px;top:0px;left:0px}.ba-common-container.react-resizable.is-both svg.resize-handler-icon-ne{width:16px;height:16px;top:0px;right:0px}.ba-common-container.react-resizable.is-both .react-resizable-handle-se{width:16px;height:16px;bottom:0;right:0;cursor:se-resize}.ba-common-container.react-resizable.is-both .react-resizable-handle-sw{width:16px;height:16px;bottom:0px;left:0px;cursor:sw-resize}.ba-common-container.react-resizable.is-both .react-resizable-handle-ne{width:16px;height:16px;top:0px;right:0px;cursor:ne-resize}.ba-common-container.react-resizable.is-both .react-resizable-handle-nw{width:16px;height:16px;top:0px;left:0px;cursor:nw-resize}", ""]);

// exports
exports.locals = {
	"containerClassName": "\"ba-common-container\""
};

/***/ }),

/***/ 11608:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Container_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21946);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Container_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Container_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Container_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Container_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Container_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Container_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Container_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Container_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 3591:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/resize-panel_24");

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 95103:
/***/ ((module) => {

"use strict";
module.exports = require("react-resizable");

/***/ }),

/***/ 56685:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__56685__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(2173));
/******/ return __webpack_exports__;
/******/ }
]);
});